import type { MetricDefinition } from "./types.js"

export type DeltaDirection = "good-up" | "bad-up" | "neutral"

const BAD_WHEN_UP = new Set(["user_deactivated", "users_removed"])

const NEUTRAL = new Set([
  "user_role",
  "user_classification",
  "application_status",
  "associated_country",
  "package_type",
  "tracking_status_breakdown",
  "checklist_country_association",
  "checklist_status",
  "task_status",
  "report_type",
  "report_generated_by",
  "tracking_created_by",
  "most_used_modules",
  "least_used_modules",
  "most_used_reports",
  "reports_by_user",
  "reports_by_module",
  "documents_per_system_tag",
  "documents_per_user_tag",
  "countries_per_country_set",
  "tasks_per_project",
  "report_countries_selected",
  "report_sections_selected",
])

export function deltaDirection(def: MetricDefinition): DeltaDirection {
  if (def.valueType === "timestamp" || def.valueType === "text") return "neutral"
  if (NEUTRAL.has(def.id)) return "neutral"
  if (def.domain === "lifecycle" || BAD_WHEN_UP.has(def.id)) return "bad-up"
  return "good-up"
}

/** Is this Δ good news? Never call it for a `neutral` metric — those show no Δ */
export function deltaIsGood(def: MetricDefinition, delta: number): boolean | null {
  const dir = deltaDirection(def)
  if (dir === "neutral" || delta === 0) return null
  return dir === "good-up" ? delta > 0 : delta < 0
}
